const TRACK_LANGUAGE_ALIASES: Record<string, string[]> = {
    en: ["en", "eng", "english", "ingles"],
    es: ["es", "spa", "spanish", "espanol", "castellano"],
};

export const normalizeTrackLanguage = (value?: string | null): string =>
    (value ?? "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

const getPreferenceCandidates = (preference?: string | null): string[] => {
    const normalized = normalizeTrackLanguage(preference);
    if (!normalized) return [];

    return Array.from(
        new Set([normalized, ...(TRACK_LANGUAGE_ALIASES[normalized] ?? [])].map(normalizeTrackLanguage)),
    );
};

export const getPreferredTrack = (
    tracks: string[],
    preference?: string | null,
): string | undefined => {
    const candidates = getPreferenceCandidates(preference);
    if (!tracks.length || !candidates.length) return tracks[0];

    return tracks.find((track) => {
        const normalizedTrack = normalizeTrackLanguage(track);
        return candidates.some(
            (candidate) =>
                normalizedTrack === candidate ||
                normalizedTrack.includes(candidate) ||
                candidate.includes(normalizedTrack),
        );
    }) ?? tracks[0];
};

export const getProfileLanguageFromTrack = (value: string): string | null => {
    const normalized = normalizeTrackLanguage(value);

    if (TRACK_LANGUAGE_ALIASES.en.some((token) => normalized.includes(token))) {
        return "en";
    }
    if (TRACK_LANGUAGE_ALIASES.es.some((token) => normalized.includes(token))) {
        return "es";
    }
    return null;
};
